import axios from 'axios';

// const CancelToken = axios.CancelToken;
// export let cancel;

const instance = axios.create({
  baseURL: 'https://gasflow.africa/v1/api'
  // baseURL: 'http://localhost:8000' // development
});

instance.interceptors.request.use(
  (request) => {
    return request;
  },
  (error) => {
    // console.log(error?.response?.data);
    return Promise.reject(error);
  }
);

// Set interceptors differently for responses
instance.interceptors.response.use(
  (response) => {
    // Edit response config
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
